module.exports = __webpack_public_path__ + "static/media/statusNegativeNoBorder.c5bde2b2.svg";